import { useEffect, useRef } from "react";

import Message from "../common/Message";
import useMessageControl from "#features/Chat/hooks/useMessageControl";
import useFileUpload from "#features/Chat/hooks/agent/useFileUpload";

const CustomMessage = ({
  onTransferNumberChange,
  onHandleDelayed = () => {},
  onHandleTicketClose = () => {},
  onHandleSurvey = () => {},
  onHandleIsOperating = () => {},
  closeModal,
  setIsLoadingModalOpen,
  openCloseChatModal,
}) => {
  const scrollRef = useRef();

  const {
    messageMap,
    userId,
    delayed,
    transferNumber,
    ticketClose,
    survey,
    closedForCall,
    closedbyAgent,
    isOperating,
    handleDeleteMessage,
    messages
  } = useMessageControl({ closeModal, setIsLoadingModalOpen }); //messageMap만 chatbot, agent로 바꾸어 사용할 수 있게 수정

  const {
    onHandleAgree,
    fileModalIsOpen,
    openFileModal,
    closeFileModal,
    handleFileChange,
    fileInputRef,
  } = useFileUpload({ ticketClose });

  //리프트 업 - transferNumber, delayed 전달
  useEffect(() => {
    if (transferNumber) {
      onTransferNumberChange(transferNumber);
    }
  }, [transferNumber, onTransferNumberChange]);

  useEffect(() => {
    onHandleDelayed(delayed);
  }, [delayed, onHandleDelayed]);

  useEffect(() => {
    onHandleTicketClose(ticketClose);
  }, [ticketClose, onHandleTicketClose]);

  useEffect(() => {
    onHandleSurvey(survey);
  }, [survey, onHandleSurvey]);

  useEffect(() => {
    onHandleIsOperating(isOperating);
  }, [isOperating, onHandleIsOperating]);

  return (
    <>
      <Message
        scrollRef={scrollRef}
        messageMap={messageMap}
        userId={userId}
        closedForCall={closedForCall}
        transferNumber={transferNumber}
        closedbyAgent={closedbyAgent}
        openCloseChatModal={openCloseChatModal}
        ticketClose={ticketClose}
        onHandleAgree={onHandleAgree}
        fileModalIsOpen={fileModalIsOpen}
        openFileModal={openFileModal}
        closeFileModal={closeFileModal}
        handleFileChange={handleFileChange}
        fileInputRef={fileInputRef}
        handleDeleteMessage={handleDeleteMessage}
        messages={messages}
      />
    </>
  );
};

export default CustomMessage;
